<template>
  <div class="sector logistic-sector">
    <div class="row">
      <div class="col-12 sector__header text-accent">
        {{ $t("carts.shippingMethod") }}
      </div>
      <div class="col-12 sector__content">
        <div class="row p-2">
          <el-radio-group v-model="form.delivery_type" size="large" class="w-full row m-0 justify-content-center">
            <template v-for="logistic in availableLogisticTypes" :key="`deliveryType_${logistic.delivery_type}`">
              <el-radio v-show="!logistic.disabled" :label="logistic.delivery_type" class="col-12 mb-2 mx-1"
                :style="{ height: 'inherit', paddingTop: '8px', paddingBottom: '8px', margin: '0 0rem 0 0' }" border>
                {{ logistic?.name || logistic.delivery_type }}
                <div v-if="logistic?.description" class="text-gray-400 text-sm w-full" style="text-wrap: initial;">{{
                  logistic.description }}</div>
              </el-radio>
            </template>
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch } from "vue";
import { useVModel } from "@vueuse/core";

const props = defineProps({
  modelValue: Object,
  availableLogisticTypes: { type: Array, default: () => [] },
});
const emit = defineEmits(["update:modelValue"]);

const form = useVModel(props, "modelValue", emit);

watch(
  () => props.availableLogisticTypes,
  (newAvailableLogisticTypes) => {
    // 強制選第一筆
    if (newAvailableLogisticTypes.length) {
      const allDeliveryTypes = newAvailableLogisticTypes.filter((i) => !i.disabled).map((i) => i.delivery_type);
      if (allDeliveryTypes.length && !allDeliveryTypes.includes(form.value.delivery_type)) {
        form.value.delivery_type = allDeliveryTypes[0];
      }
    }
  },
  { deep: true, immediate: true }
);

</script>
<style lang="scss">
.logistic-sector {
  .el-radio__label {
    margin-left: 0.3rem;
    font-size: 1rem !important;
  }

  .el-radio.is-bordered.is-checked {
    background: aliceblue;
  }
}
</style>
